/**
 * MasterClassCancelModal - Модальное окно для отмены мастер-класса
 */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Textarea,
  Button,
  Group,
  Stack,
  Text,
  Alert,
} from '@mantine/core';
import { IconAlertTriangle, IconCalendarEvent, IconX } from '@tabler/icons-react';
import tokens from '../../../theme/designTokens';

/**
 * Форматирование даты
 */
const formatDate = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return date.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Moscow',
  });
};

/**
 * Получить первый предмет из групп
 */
const getFirstSubjectName = (groups) => {
  if (!groups || groups.length === 0) return 'Без предмета';
  const firstGroup = groups[0];
  return firstGroup.subject_name || 'Без предмета';
};

const MasterClassCancelModal = ({
  opened,
  onClose,
  onConfirm,
  masterClass,
  loading = false,
}) => {
  const [reason, setReason] = useState('');

  // Сбрасываем форму при открытии
  useEffect(() => {
    if (opened) {
      setReason('');
    }
  }, [opened]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await onConfirm(reason.trim() || null);
    } catch (err) {
      // Ошибка обработается в родительском компоненте
    }
  };

  if (!masterClass) return null;

  const subjectName = getFirstSubjectName(masterClass.groups);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Отмена мастер-класса"
      size="md"
      radius="xl"
      styles={{
        content: {
          borderRadius: '16px',
        },
      }}
    >
      <form onSubmit={handleSubmit}>
        <Stack gap="md">
          {/* Предупреждение */}
          <Alert
            icon={<IconAlertTriangle size={16} />}
            color="orange"
            variant="light"
          >
            Вы уверены, что хотите отменить мастер-класс?
          </Alert>

          {/* Информация о МК */}
          <Group gap="xs" p="sm" style={{
            backgroundColor: tokens.colors.neutral[1],
            borderRadius: '8px',
          }}>
            <IconCalendarEvent size={18} color={tokens.colors.brand.primary} />
            <Text size="sm">
              МК: {formatDate(masterClass.scheduled_at)} • {subjectName}
            </Text>
          </Group>

          {/* Причина отмены */}
          <Textarea
            label="Причина отмены"
            placeholder="Укажите причину отмены (опционально)..."
            autosize
            minRows={3}
            maxRows={6}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />

          {/* Предупреждение о необратимости */}
          <Alert
            icon={<IconX size={16} />}
            color="red"
            variant="light"
          >
            Это действие нельзя отменить!
          </Alert>

          {/* Кнопки */}
          <Group justify="flex-end" mt="md">
            <Button variant="subtle" onClick={onClose}>
              Назад
            </Button>
            <Button type="submit" loading={loading} color="red">
              Отменить МК
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default MasterClassCancelModal;
